<div>
    <app-documentsetting></app-documentsetting>
</div>
<div>
    <app-documentsetting-list></app-documentsetting-list>
</div>
